import { styled } from "goober";

export const PageContainer = styled("div")`
  --page-padding: var(--sp-4);
  --section-gap: var(--sp-3);

  flex: 1;

  display: flex;
  flex-direction: column;

  width: 100%;
  max-width: 100%;

  hr {
    width: 100%;
    height: var(--sp-px);
    margin: 0;

    border: none;
    border-top: var(--sp-px) solid var(--shade3-15);

    outline: none;
  }
`;
